(() => {
  const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const pad = n => String(n).padStart(2, "0");

  /* ---------- Slideshow ---------- */
  document.querySelectorAll("[data-slideshow]").forEach(show => {
    const slides = [...show.querySelectorAll(".slide")];
    if (slides.length < 2) return;
    const captionOut = show.querySelector("[data-caption-out]");
    const counter = show.querySelector("[data-counter]");
    const interval = (Number(show.dataset.interval) || 5) * 1000;
    let current = 0, timer = null;

    const go = i => {
      slides[current].classList.remove("on");
      current = (i + slides.length) % slides.length;
      slides[current].classList.add("on");
      if (captionOut) captionOut.textContent = slides[current].dataset.caption || "";
      if (counter) counter.textContent = `${pad(current + 1)} / ${pad(slides.length)}`;
    };
    const restart = () => {
      clearInterval(timer);
      if (!reduceMotion) timer = setInterval(() => go(current + 1), interval);
    };

    show.querySelector("[data-prev]")?.addEventListener("click", () => { go(current - 1); restart(); });
    show.querySelector("[data-next]")?.addEventListener("click", () => { go(current + 1); restart(); });

    let touchX = null;
    show.addEventListener("touchstart", e => { touchX = e.touches[0].clientX; }, { passive: true });
    show.addEventListener("touchend", e => {
      if (touchX === null) return;
      const dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) { go(current + (dx < 0 ? 1 : -1)); restart(); }
      touchX = null;
    });

    // Theme editor: show the selected slide and pause
    document.addEventListener("shopify:block:select", e => {
      const i = slides.indexOf(e.target);
      if (i > -1) { go(i); clearInterval(timer); }
    });
    document.addEventListener("shopify:block:deselect", restart);

    restart();
  });

  /* ---------- Phone menu ---------- */
  const toggle = document.querySelector("[data-menu-toggle]");
  const nav = document.getElementById("site-nav");
  toggle?.addEventListener("click", () => {
    const open = nav.classList.toggle("open");
    toggle.setAttribute("aria-expanded", String(open));
    toggle.textContent = open ? "Close" : "Menu";
  });

  /* ---------- Cart count ---------- */
  const setCount = count => {
    document.querySelectorAll("[data-cart-count]").forEach(el => { el.textContent = count; });
  };
  const cartAddUrl = (window.Shopify?.routes?.root || "/") + "cart/add.js";
  const cartUrl = (window.Shopify?.routes?.root || "/") + "cart.js";

  /* ---------- Quick add on product tiles ---------- */
  document.addEventListener("submit", async e => {
    const form = e.target.closest("[data-quick-add]");
    if (!form) return;
    e.preventDefault();
    const button = form.querySelector("button");
    button.disabled = true;
    try {
      const res = await fetch(cartAddUrl, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(form),
      });
      if (!res.ok) throw new Error((await res.json()).description || "Could not add");
      const cart = await (await fetch(cartUrl)).json();
      setCount(cart.item_count);
      button.textContent = "Added";
      button.classList.add("done");
    } catch (err) {
      button.textContent = "Sold out";
    } finally {
      setTimeout(() => {
        button.disabled = false;
        if (button.textContent === "Added") {
          button.textContent = "Add to cart";
          button.classList.remove("done");
        }
      }, 1600);
    }
  });

  /* ---------- Variant select on product page ---------- */
  const select = document.querySelector("[data-variant-select]");
  if (select) {
    const priceEl = document.querySelector("[data-price]");
    const addBtn = document.querySelector("[data-add-button]");
    select.addEventListener("change", () => {
      const opt = select.selectedOptions[0];
      const available = opt.dataset.available === "true";
      if (priceEl) priceEl.textContent = opt.dataset.price;
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? "Add to cart" : "Sold out";
      }
      const url = new URL(location.href);
      url.searchParams.set("variant", select.value);
      history.replaceState({}, "", url);
    });
  }

  /* ---------- Welcome pop-up ---------- */
  const popup = document.querySelector("[data-popup]");
  if (popup) {
    const KEY = "addeed-welcome-popup";
    const read = () => { try { return localStorage.getItem(KEY); } catch { return null; } };
    const write = v => { try { localStorage.setItem(KEY, v); } catch {} };
    let lastFocus = null;

    const open = () => {
      lastFocus = document.activeElement;
      popup.hidden = false;
      (popup.querySelector('input[type="email"]') || popup.querySelector("[data-copy]") || popup.querySelector(".popup-x"))?.focus();
    };
    const close = () => {
      popup.hidden = true;
      if (read() !== "joined") write("closed");
      lastFocus?.focus?.();
    };

    popup.querySelectorAll("[data-popup-close]").forEach(el => el.addEventListener("click", close));
    document.addEventListener("keydown", e => { if (e.key === "Escape" && !popup.hidden) close(); });
    popup.closest("form")?.addEventListener("submit", () => write("joined"));

    const inEditor = window.Shopify && window.Shopify.designMode;
    if (popup.hasAttribute("data-posted")) {
      write("joined");
      open();
    } else if (inEditor) {
      // Theme editor: show it while the section is selected
      document.addEventListener("shopify:section:select", e => { if (e.target.contains(popup)) open(); });
      document.addEventListener("shopify:section:deselect", e => { if (e.target.contains(popup)) popup.hidden = true; });
    } else if (!read()) {
      setTimeout(open, (Number(popup.dataset.delay) || 6) * 1000);
    }
  }

  // Footer sign-up from another page: mark as joined so the pop-up stays away
  document.getElementById("footer-newsletter")?.addEventListener("submit", () => {
    try { localStorage.setItem("addeed-welcome-popup", "joined"); } catch {}
  });

  /* ---------- Copy email ---------- */
  document.querySelectorAll("[data-copy]").forEach(btn => {
    btn.addEventListener("click", () => {
      const source = btn.parentElement.querySelector("[data-copy-source]");
      const text = source.textContent.trim();
      const reset = label => { btn.textContent = label; setTimeout(() => { btn.textContent = "Copy"; }, 1400); };
      navigator.clipboard?.writeText(text).then(() => reset("Copied"), () => {
        const range = document.createRange();
        range.selectNodeContents(source);
        const sel = getSelection(); sel.removeAllRanges(); sel.addRange(range);
        reset("Selected");
      });
    });
  });
})();
